import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import './style.scss'

export const notify = (type, title) => {
  toast[`${type}`](title, {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  })
}
